"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-check

/**
 * @param {V2.RefundDataGrouping} _
 * @returns {V2.RefundPolicyGroupInfo}
 */
function selfServeRefundTerms(_) {
  // eslint-disable-line no-unused-vars
  return {
    icon: "dollar-sign",
    method: "!refund-and-exchange.content.refund.self-serve.method",
    method_simplified: "!refund-and-exchange.content.refund.self-serve.method.simplified"
  };
}

exports.default = selfServeRefundTerms;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy92Mi9yZWZ1bmRzL3NlbGYtc2VydmUtcmVmdW5kcy5qcyJdLCJuYW1lcyI6WyJzZWxmU2VydmVSZWZ1bmRUZXJtcyIsIl8iLCJpY29uIiwibWV0aG9kIiwibWV0aG9kX3NpbXBsaWZpZWQiXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUE7O0FBRUE7Ozs7QUFJQSxTQUFTQSxvQkFBVCxDQUE4QkMsQ0FBOUIsRUFBaUM7QUFDL0I7QUFDQSxTQUFPO0FBQ0xDLFVBQU0sYUFERDtBQUVMQyxZQUFRLHVEQUZIO0FBR0xDLHVCQUFtQjtBQUhkLEdBQVA7QUFLRDs7a0JBRWNKLG9CIiwiZmlsZSI6InNlbGYtc2VydmUtcmVmdW5kcy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEB0cy1jaGVja1xuXG4vKipcbiAqIEBwYXJhbSB7VjIuUmVmdW5kRGF0YUdyb3VwaW5nfSBfXG4gKiBAcmV0dXJucyB7VjIuUmVmdW5kUG9saWN5R3JvdXBJbmZvfVxuICovXG5mdW5jdGlvbiBzZWxmU2VydmVSZWZ1bmRUZXJtcyhfKSB7XG4gIC8vIGVzbGludC1kaXNhYmxlLWxpbmUgbm8tdW51c2VkLXZhcnNcbiAgcmV0dXJuIHtcbiAgICBpY29uOiBcImRvbGxhci1zaWduXCIsXG4gICAgbWV0aG9kOiBcIiFyZWZ1bmQtYW5kLWV4Y2hhbmdlLmNvbnRlbnQucmVmdW5kLnNlbGYtc2VydmUubWV0aG9kXCIsXG4gICAgbWV0aG9kX3NpbXBsaWZpZWQ6IFwiIXJlZnVuZC1hbmQtZXhjaGFuZ2UuY29udGVudC5yZWZ1bmQuc2VsZi1zZXJ2ZS5tZXRob2Quc2ltcGxpZmllZFwiXG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IHNlbGZTZXJ2ZVJlZnVuZFRlcm1zO1xuIl19